(() => {
  // Runs ONLY on the Bridal Boxes product page (change handle if yours differs)
  const BRIDAL_BOXES_PATH = "/products/bridal-boxes";
  if (!location.pathname.includes(BRIDAL_BOXES_PATH)) return;

  window.GS_YMQ_BRIDAL_BOXES_FIXED = true;
  console.log("[GS] Bridal Boxes YMQ marker loaded");

  const LABELS_TO_MARK = [
    "personalisation (top of box)",
    "personalise (inside)"
  ];

  function markBoxes() {
    const ymqBox = document.querySelector("#ymq-box");
    if (!ymqBox) return;

    ymqBox.querySelectorAll(".ymq-options-box").forEach((box) => {
      const dataLabel = (box.getAttribute("data-label") || "").toLowerCase();
      if (LABELS_TO_MARK.some((x) => dataLabel.includes(x))) {
        box.classList.add("gs-ymq-bb-text-only");
      }
    });
  }

  function boot() {
    markBoxes();

    const target = document.querySelector("#ymq-box") || document.body;
    const mo = new MutationObserver(markBoxes);
    mo.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
